import { Container } from "@/components/Container/Container";
import { chrome } from "@/spiel/chrome";
import styles from "./Footer.module.scss";

export const Footer = () => (
  <footer className={styles.footer}>
    <Container>
      <div className={styles.inner}>
        <img
          src="/devarmlogo.svg"
          alt={chrome.brandName}
          width={96}
          height={32}
        />
        <p className={styles.copy}>{chrome.footerTagline}</p>
        <a href={`mailto:${chrome.email}`} className={styles.email}>
          {chrome.email}
        </a>
      </div>
    </Container>
  </footer>
);
